/* eslint-disable */

import Vue from 'vue';
import VueRouter from 'vue-router';

import AboutUs from '@/pages/about-us/Index.vue';
import Career from '@/pages/career/Index.vue';
import Contacts from '@/pages/contacts/Index.vue';
import Main from '@/pages/main/Index.vue';
import News from '@/pages/news/Index.vue';
import NewsItem from '@/pages/news/Item.vue';
import NotFound from '@/pages/not-found/Index.vue';
import PrivacyPolicy from '@/pages/privacy-policy/Index.vue';

Vue.use(VueRouter);

const routes = [
    {
      component: AboutUs,
      name: 'AboutUs',
      path: '/about',
      meta: {
        title: '4MKTG | Trade marketing projects — about us',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — about us',
          },
          {
            name: 'description',
            content: 'Creatività e razionalità. Il giusto mix tra l’innovazione dei creativi e la nostra esperienza di field marketing. Siamo nati così, nel 1996. ',
          },
          {
            property: 'og:description',
            content: 'Creatività e razionalità. Il giusto mix tra l’innovazione dei creativi e la nostra esperienza di field marketing. Siamo nati così, nel 1996. ',
          },
        ],
      },
    },
    {
      component: Career,
      name: 'Career',
      path: '/career',
      meta: {
        title: '4MKTG | Trade marketing projects — career',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — career',
          },
          {
            name: 'description',
            content: 'Siamo sempre alla ricerca di nuovi talenti per incrementare il nostro team: passione, impegno e volontà di portare buoni risultati sono requisiti indispensabili.',
          },
          {
            property: 'og:description',
            content: 'Siamo sempre alla ricerca di nuovi talenti per incrementare il nostro team: passione, impegno e volontà di portare buoni risultati sono requisiti indispensabili.',
          },
        ],
      },
    },
    {
      component: Contacts,
      name: 'Contacts',
      path: '/contacts',
      meta: {
        title: '4MKTG | Trade marketing projects — contacts',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — contacts',
          },
          {
            name: 'description',
            content: 'Headquarter: tel. +390396854596 | Email: info@4mktg.it |Ind.: Via Torri Bianche 10 edificio Betulla | CAP: 20871 Vimercate | Fax: +390396084091',
          },
          {
            property: 'og:description',
            content: 'Headquarter: tel. +390396854596 | Email: info@4mktg.it |Ind.: Via Torri Bianche 10 edificio Betulla | CAP: 20871 Vimercate | Fax: +390396084091',
          },
        ],
      },
    },
    {
      component: NewsItem,
      name: 'NewsItem',
      path: '/news/:id(\\d+)',
      props: (route) => ({id: +route.params.id}),
      meta: {
        title: '4MKTG | Trade marketing projects — news',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — news',
          },
          {
            name: 'description',
            content: 'Stay up to date with the most recent 4MKTG related news stories.',
          },
          {
            property: 'og:description',
            content: 'Stay up to date with the most recent 4MKTG related news stories.',
          },
        ],
      },
    },
    {
      component: News,
      name: 'News',
      path: '/news',
      meta: {
        title: '4MKTG | Trade marketing projects — news',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — news',
          },
          {
            name: 'description',
            content: 'Stay up to date with the most recent 4MKTG related news stories.',
          },
          {
            property: 'og:description',
            content: 'Stay up to date with the most recent 4MKTG related news stories.',
          },
        ],
      },
    },
    {
      component: PrivacyPolicy,
      name: 'PrivacyPolicy',
      path: '/privacy',
      meta: {
        title: '4MKTG | Trade marketing projects — privacy',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — privacy',
          },
          {
            name: 'description',
            content: '4MKTG | Trade marketing projects — privacy',
          },
          {
            property: 'og:description',
            content: '4MKTG | Trade marketing projects — privacy',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/',
      meta: {
        title: '4MKTG | Trade marketing projects',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects',
          },
          {
            name: 'description',
            content: 'We work in trade marketing and related services. Undertaking tasks for HoReCa, merchandising, logistics, events and creative, we deliver efficient decisions that meet business needs.',
          },
          {
            property: 'og:description',
            content: 'We work in trade marketing and related services. Undertaking tasks for HoReCa, merchandising, logistics, events and creative, we deliver efficient decisions that meet business needs.',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(horeca)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — horeca',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — horeca',
          },
          {
            name: 'description',
            content: 'Il tuo prodotto nei migliori bar con la miglior visibilità. In questo canale generiamo valore creando interesse per i prodotti che trattiamo sia nei gestori dei locali che nei loro clienti. ',
          },
          {
            property: 'og:description',
            content: 'Il tuo prodotto nei migliori bar con la miglior visibilità. In questo canale generiamo valore creando interesse per i prodotti che trattiamo sia nei gestori dei locali che nei loro clienti. ',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(gdo)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — presidio GDO',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — presidio GDO',
          },
          {
            name: 'description',
            content: 'La miglior visibilità a scaffale e in extra display. Mettiamo il tuo prodotto nelle mani del consumatore.',
          },
          {
            property: 'og:description',
            content: 'La miglior visibilità a scaffale e in extra display. Mettiamo il tuo prodotto nelle mani del consumatore.',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(logistics)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — logistics',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — logistics',
          },
          {
            name: 'description',
            content: 'La nostra struttura logistica per trasportare i tuoi materiali promozionali nei modi, nei luoghi e nei tempi corretti.',
          },
          {
            property: 'og:description',
            content: 'La nostra struttura logistica per trasportare i tuoi materiali promozionali nei modi, nei luoghi e nei tempi corretti.',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(events)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — events',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — events',
          },
          {
            name: 'description',
            content: 'Le location adatte, il target corretto. I migliori eventi per far desiderare il tuo prodotto ai consumatori. Gli eventi rappresentano l’altra identità storica di 4MKTG. ',
          },
          {
            property: 'og:description',
            content: 'Le location adatte, il target corretto. I migliori eventi per far desiderare il tuo prodotto ai consumatori. Gli eventi rappresentano l’altra identità storica di 4MKTG. ',
          },
        ],
      },
    },
    {
      component: Main,
      name: 'Main',
      path: '/:slideURL(creative)',
      props: true,
      meta: {
        title: '4MKTG | Trade marketing projects — Not Found',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — Not Found',
          },
          {
            name: 'description',
            content: 'Idee creative per presentare il tuo prodotto al trade e ai consumatori. In 4MKTG creiamo materiali e contenuti per promuovere i prodotti che ci vengono affidati. ',
          },
          {
            property: 'og:description',
            content: 'Idee creative per presentare il tuo prodotto al trade e ai consumatori. In 4MKTG creiamo materiali e contenuti per promuovere i prodotti che ci vengono affidati. ',
          },
        ],
      },
    },
    {
      alias: '*',
      component: NotFound,
      name: 'NotFound',
      path: '/404',
      meta: {
        title: '4MKTG | Trade marketing projects — Not Found',
        metaTags: [
          {
            name: 'og:title',
            content: '4MKTG | Trade marketing projects — Not Found',
          },
          {
            name: 'description',
            content: '4MKTG | Trade marketing projects — Not Found',
          },
          {
            property: 'og:description',
            content: '4MKTG | Trade marketing projects — Not Found',
          },
        ],
      },
    },
  ];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior,
  linkActiveClass: 'link_active',
  linkExactActiveClass: 'link_exact',
  routes: routes,
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find((r) =>
    (r.meta && r.meta.title)
  );

  if (to.hash === '#100') {
    setTimeout(() => {
      window.scrollTo({left: 0, top: document.body.scrollHeight, behavior: 'smooth'});
    }, 200);
  }

  const nearestWithMeta = to.matched.slice().reverse().find((r) =>
    r.meta && r.meta.metaTags);

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  const element = document.querySelectorAll('[data-vue-router-controlled]');
  Array.from(element).map((el) =>
    el.parentNode.removeChild(el));

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map((tagDef) => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach((key) => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;

/**
 * @param {Object} to
 * @param {Object} from
 * @param {Object} savedPosition
 * @return {Object}
 */
function scrollBehavior(to, from, savedPosition) {
  if (to && to.hash) {
    return {
      selector: to.hash,
      behavior: 'smooth'
    };
  } else if (savedPosition) {
      return savedPosition;
  } else {
      return { x: 0, y: 0 };
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js